<script setup lang="ts">
import { computed } from 'vue';

import { BoardBasisCode } from '@libs/trip-planner-interfaces';
import { AppSvgIcon } from '@libs/ui';

interface BoardBasisTagProps {
  boardBasisCode: BoardBasisCode;
  areOtherBoardBasisOptionsAvailable: boolean;
  translationsCallback: (code: BoardBasisCode) => string;
}

const props = defineProps<BoardBasisTagProps>();

const boardBasisLabel = computed<string | undefined>(() => {
  if (props.boardBasisCode === BoardBasisCode.RO) {
    return undefined;
  }
  return props.translationsCallback(props.boardBasisCode);
});
</script>

<template>
  <div v-if="boardBasisLabel" class="board-basis-tag">
    <AppSvgIcon name="food" size="18" color="color-neutral-70" />
    <div class="meal-info">
      <span>{{ boardBasisLabel }}</span>
      <span v-if="props.areOtherBoardBasisOptionsAvailable">
        <span>.&nbsp;</span>
        <span class="extra-info">
          {{ $t('planner.other_meal_plans_available') }}
        </span>
      </span>
    </div>
  </div>
</template>

<style scoped lang="scss">
.board-basis-tag {
  display: flex;
  align-self: flex-start;
  align-items: center;
  gap: var(--spacing-4);
  padding-top: var(--spacing-4);

  .meal-info {
    @include font-body-s-bold;

    .extra-info {
      @include font-body-s-light;
    }
  }
}
</style>
